.container {
  padding: 20px 0;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 20px;
}

.section-title h3 {
  margin: 0px;
}
.section-title .icon {
  color: var(--button-primary-color);
}

.section-content--solid {
  background-color: var(--section-background);
  border-radius: 5px;
  padding: 20px;
}

.section-content--transparent {
  background-color: transparent;
  border-radius: 0px;
  padding: 0px;
}
